// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_layouts_ConfirmationLayout_vue":"b5dd5e3f","src_layouts_DefaultLayout_vue":"81a511d8"}[chunkId] + ".css";
};